"use client"

import MinimalMenuHero from "./components/MenuHero"
import MinimalFooter from "./components/Footer"
import CategoriesSection from "@/components/categories-section"
import BeveragesSection from "@/components/beverages-section"
import OrderStatusModal from "@/components/order-status-modal"
import OrderCompletionModal from "@/components/order-completion-modal"
import ConnectionStatus from "@/components/connection-status"
import NotificationContainer from "@/components/notification-container"
import FloatingNav from "@/components/floating-nav"
import BuffetAd from "@/components/buffet-ad"
import { useApp } from "@/lib/context"

interface MenuTemplateProps {
    isLoading?: boolean
    onLoadingComplete?: () => void
}

export default function MinimalMenu({ isLoading = false, onLoadingComplete }: MenuTemplateProps) {
    const { categoriesBebidas } = useApp()

    return (
        <main className="min-h-screen bg-background">
            {/* Minimal Theme: Stark black/white, high contrast, geometric */}

            <MinimalMenuHero />

            <BuffetAd />

            <div className="border-t-4 border-foreground py-12">
                <CategoriesSection variant="minimal" />
            </div>

            {categoriesBebidas.length > 0 && (
                <div className="border-t-4 border-foreground py-12">
                    <BeveragesSection />
                </div>
            )}

            <MinimalFooter />

            {/* Modais e overlays partilhados */}
            <OrderStatusModal />
            <OrderCompletionModal />
            <NotificationContainer />
            <ConnectionStatus />
            <FloatingNav />
        </main>
    )
}
